import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

const styles = theme => ({
  root: {
    whiteSpace: 'nowrap',
    height: '36px',
    padding: '0 16px',
    color: theme.buttons.marketplaceButtonColor,
    backgroundColor: theme.buttons.marketplaceButtonBg,
    fontWeight: theme.typography.fontWeightBold,
    '&.rowActionItem': {
      fontSize: theme.typography.fontSizeSmaller,
      fontWeight: theme.typography.fontWeightNormal,
      height: 30,
      minWidth: 30,
      padding: '0 14px',
      'button + &': {
        marginLeft: 10,
        '.buttonGroup &': {
          marginLeft: 1,
        },
      },
    },
    '& a': {
      fontWeight: '300',
    },
    '& a:hover': {
      textDecoration: 'none',
    },
    '&:hover': {
      color: theme.buttons.marketplaceButtonColor,
      backgroundColor: theme.buttons.marketplaceButtonBgHover,
    },
    '&:disabled': {
      color: theme.buttons.marketplaceButtonColor,
      backgroundColor: theme.buttons.marketplaceButtonBgHover,
      opacity: 0.5,
    },
  },
})

function ClassNames(props) {
  const { children, className, onClick, variant, classes, style, ...rest } = props
  return (
    <Button variant={variant} className={cn(classes.root, className)} style={{ ...style }} onClick={onClick} {...rest}>
      {!children ? 'class names' : children}
    </Button>
  )
}

ClassNames.defaultProps = {
  variant: 'contained',
}

const DeleteButton = withStyles(styles)(ClassNames)
DeleteButton.displayName = 'DeleteButton'
export default DeleteButton
